import { addNotificationEvent } from 'shared/components'

export async function handleReCaptchaVerify(executeRecaptcha: any) {
  if (!executeRecaptcha) {
    console.error('Execute recaptcha not yet available')
    handleTokenError()
    return await new Promise((resolve, reject) => reject())
  }

  return await executeRecaptcha?.('submit')
}

export function handleTokenError(): void {
  addNotificationEvent({
    type: 'error',
    description:
      'Произошла ошибка при проверке reCAPTCHA. Пожалуйста, попробуйте снова.',
  })
}
